import FlexPane from './_flex-pane.js'
import TaxAbsorptionDisclaimer from './_tax-absorption-disclaimer.js'
import PlaceBetButton from './_place-bet-button.js'
import PlaceBetCalculations from './_place-bet-calculations.js'
import BetslipSettings from './_betslip-settings.js'
import PlacementMessages from './_placement-messages.js'
import Text from './_text.js'

export default {
  name: 'PlaceBetContent',
  values: {
    placeBetContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 8px 0px 8px',
          flexDirection: 'column',
        },
      },
    },
    placeBetInnerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 0 0 0',
          flexDirection: 'column',
        },
      },
    },
    taxAbsorptionDisclaimer: {
      configSet: TaxAbsorptionDisclaimer,
      configValues: {},
    },
    placeBetButton: {
      configSet: PlaceBetButton,
      configValues: {},
    },
    placeBetCalculations: {
      configSet: PlaceBetCalculations,
      configValues: {},
    },
    commitBetslipContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'space-between',
          padding: '16px 0',
        },
      },
    },
    betslipButtonsContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        itemSpacing: '8px',
      },
    },
    betslipSettings: {
      configSet: BetslipSettings,
      configValues: {
        hide: true,
      },
    },
    placementMessages: {
      configSet: PlacementMessages,
      configValues: {},
    },
    userNotInTheShopNotification: {
      configSet: Text,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
